// developed by Param Partap Singh

import React from 'react'; 
import { BrowserRouter, Route ,Routes } from 'react-router-dom'; // React Router setup
import './App.css';
import Home from './Component/Pages/Home';
import About from './Component/Pages/About';
import Network from './Component/Pages/Network';
import ScrollTop from './Component/Utils/ScrollTop';
import Software from './Component/Pages/Software';
import Police from './Component/Pages/Police';
import Cloud from './Component/Pages/Cloud';
import Application from './Component/Pages/Application';
import Start from './Component/Pages/Start';
import Specifications from './Component/Pages/GPU/Specifications';
import Manuals from './Component/Pages/GPU/Manuals';
import SupportTeam from './Component/Pages/GPU/SupportTeam';
import Eduroam from './Component/Pages/Eduroam';

function App() {
  return (
    <BrowserRouter basename={'/it'}>
      <ScrollTop/>
      <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="/about" element={<About/>}/>
        <Route path="/network" element={<Network/>}/>
        <Route path="/software" element={<Software/>}/>
        <Route path="/police" element={<Police/>}/>
        <Route path="/cloud" element={<Cloud/>}/>
        <Route path="/application" element={<Application/>}/>
        <Route path="/start" element={<Start/>}/>
        <Route path="/gpuspecs" element={<Specifications/>}/>
        <Route path="/manuals" element={<Manuals/>}/>
        <Route path="/support" element={<SupportTeam/>}/>
        <Route path="/eduroam" element={<Eduroam/>}/> {/* Eduroam page can be reused from Start component */}

      </Routes>
      
    </BrowserRouter>
  );
}

export default App;

